module.exports = __webpack_public_path__ + "static/media/client13.1613d42b.webp";